// extracted by mini-css-extract-plugin
export default {"image-container":"image_image-container__xRghI","image":"image_image__H7MvK","loader":"image_loader__cjqf6"};